module.exports = __webpack_public_path__ + "img/drive_green.1a057b59.jpg";